<template>
  <div class="hexiao-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">禾销</h1>
        <p class="page-subtitle">智能营销管理系统</p>
      </div>
    </div>

    <!-- 产品介绍 -->
    <section class="intro-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <h2 class="section-title">产品概述</h2>
            <p class="section-description">
              禾销是一款专为企业打造的智能营销管理系统，集成客户管理、销售管理、数据分析于一体，帮助企业提升销售效率，优化营销流程，实现精准获客。
            </p>
            <ul class="feature-list">
              <li class="feature-item">
                <i class="iconfont icon-check-circle"></i>
                <span>智能客户画像分析</span>
              </li>
              <li class="feature-item">
                <i class="iconfont icon-check-circle"></i>
                <span>自动化营销流程管理</span>
              </li>
              <li class="feature-item">
                <i class="iconfont icon-check-circle"></i>
                <span>多维度数据分析报表</span>
              </li>
              <li class="feature-item">
                <i class="iconfont icon-check-circle"></i>
                <span>全渠道客户触达能力</span>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <img 
              src="../assets/images/hemiao.aafbc56b.gif" 
              alt="禾销产品概述" 
              class="product-image img-fluid"
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
    <section class="features-section">
      <div class="container">
        <h2 class="section-title text-center">核心功能</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="iconfont icon-book"></i>
              </div>
              <h3 class="feature-title">客户关系管理</h3>
              <p class="feature-description">
                全面记录客户信息，跟踪客户互动历史，构建客户画像，实现客户全生命周期管理。
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="iconfont icon-clock"></i>
              </div>
              <h3 class="feature-title">销售流程自动化</h3>
              <p class="feature-description">
                可视化销售漏斗，智能任务提醒，自动化跟进流程，提高销售转化率和工作效率。
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="iconfont icon-shield"></i>
              </div>
              <h3 class="feature-title">数据分析与洞察</h3>
              <p class="feature-description">
                多维度数据报表，智能数据分析，帮助企业了解市场趋势和客户需求，优化营销策略。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品优势 -->
    <section class="advantages-section">
      <div class="container">
        <h2 class="section-title text-center">产品优势</h2>
        <div class="row">
          <div class="col-md-3">
            <div class="advantage-item">
              <h3>精准获客</h3>
              <p>基于大数据分析，精准定位目标客户群体，提高获客质量和效率。</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="advantage-item">
              <h3>智能管理</h3>
              <p>AI驱动的智能推荐和自动化管理，减少人工操作，提高管理效率。</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="advantage-item">
              <h3>实时协同</h3>
              <p>团队成员实时协同工作，信息共享，提高团队协作效率。</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="advantage-item">
              <h3>安全可靠</h3>
              <p>多重安全防护机制，确保数据安全，符合企业级安全标准。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="scenarios-section">
      <div class="container">
        <h2 class="section-title text-center">应用场景</h2>
        <div class="row">
          <div class="col-md-6">
            <div class="scenario-item">
              <h3>电商企业</h3>
              <p>管理客户订单，分析购买行为，个性化推荐产品，提升客户复购率。</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="scenario-item">
              <h3>教育培训</h3>
              <p>跟踪学员信息，管理课程销售，提升转化率，优化教学效果。</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="scenario-item">
              <h3>金融服务</h3>
              <p>客户风险评估，精准营销，提升服务质量，增强客户满意度。</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="scenario-item">
              <h3>企业服务</h3>
              <p>管理企业客户，跟踪服务进度，提高续约率，扩大业务规模。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <section class="testimonials-section">
      <div class="container">
        <h2 class="section-title text-center">客户评价</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="testimonial-card">
              <div class="rating">
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
              </div>
              <p class="testimonial-content">
                "禾销系统帮助我们显著提升了销售效率，客户转化率提高了30%，是我们企业数字化转型的得力助手。"
              </p>
              <div class="testimonial-author">
                <img src="../assets/images/1.670c7eef.gif" alt="客户1" class="author-avatar">
                <div class="author-info">
                  <h4>张总</h4>
                  <p>某科技公司 CEO</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="testimonial-card">
              <div class="rating">
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star-half"></i>
              </div>
              <p class="testimonial-content">
                "数据分析功能非常强大，让我们能够更深入地了解客户需求，制定更精准的营销策略。"
              </p>
              <div class="testimonial-author">
                <img src="../assets/images/2.0a9650a7.gif" alt="客户2" class="author-avatar">
                <div class="author-info">
                  <h4>李经理</h4>
                  <p>某电商企业 市场总监</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="testimonial-card">
              <div class="rating">
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
                <i class="iconfont icon-star"></i>
              </div>
              <p class="testimonial-content">
                "系统操作简单易用，团队学习成本低，售后服务响应迅速，是一款值得推荐的营销管理工具。"
              </p>
              <div class="testimonial-author">
                <img src="../assets/images/banner.png" alt="客户3" class="author-avatar">
                <div class="author-info">
                  <h4>王总监</h4>
                  <p>某教育机构 运营总监</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系咨询 -->
    <section class="contact-section">
      <div class="container">
        <h2 class="section-title text-center">联系咨询</h2>
        <div class="contact-form-container">
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name">姓名</label>
              <input 
                type="text" 
                id="name" 
                v-model="formData.name" 
                class="form-control" 
                placeholder="请输入您的姓名"
                required
              >
            </div>
            <div class="form-group">
              <label for="company">公司名称</label>
              <input 
                type="text" 
                id="company" 
                v-model="formData.company" 
                class="form-control" 
                placeholder="请输入公司名称"
                required
              >
            </div>
            <div class="form-group">
              <label for="phone">联系电话</label>
              <input 
                type="tel" 
                id="phone" 
                v-model="formData.phone" 
                class="form-control" 
                placeholder="请输入联系电话"
                required
              >
            </div>
            <div class="form-group">
              <label for="email">邮箱</label>
              <input 
                type="email" 
                id="email" 
                v-model="formData.email" 
                class="form-control" 
                placeholder="请输入邮箱地址"
                required
              >
            </div>
            <div class="form-group">
              <label for="message">咨询内容</label>
              <textarea 
                id="message" 
                v-model="formData.message" 
                class="form-control" 
                rows="4" 
                placeholder="请输入您的咨询内容"
                required
              ></textarea>
            </div>
            <button type="submit" class="btn btn-primary submit-btn">提交咨询</button>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HeXiao',
  data() {
    return {
      formData: {
        name: '',
        company: '',
        phone: '',
        email: '',
        message: ''
      }
    }
  },
  metaInfo: {
    title: '禾销 - 智能营销管理系统 - 禾苗（武汉）信息技术有限公司'
  },
  methods: {
    handleSubmit() {
      // 模拟表单提交
      console.log('Form submitted:', this.formData)
      alert('感谢您的咨询，我们会尽快与您联系！')
      // 重置表单
      this.formData = {
        name: '',
        company: '',
        phone: '',
        email: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.hexiao-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 页面标题 */
.page-header {
  background-image: url('../assets/images/banner.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 60px 0;
  text-align: center;
}

.page-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 1.25rem;
  opacity: 0.9;
}

/* 通用区块样式 */
section {
  padding: 80px 0;
}

.section-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 1.5rem;
}

.section-description {
  font-size: 1.1rem;
  color: #6c757d;
  line-height: 1.8;
  margin-bottom: 2rem;
}

/* 产品介绍 */
.intro-section {
  background-color: #f8f9fa;
}

.product-image {
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.product-image:hover {
  transform: translateY(-5px);
}

.feature-list {
  list-style: none;
  padding: 0;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #495057;
}

.feature-item i {
  color: #28a745;
  margin-right: 10px;
  font-size: 1.25rem;
}

/* 核心功能 */
.features-section {
  background-color: white;
}

.feature-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
  height: 100%;
}

.feature-card:hover {
  background: white;
  transform: translateY(-10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  width: 80px;
  height: 80px;
  background: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 2.5rem;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #343a40;
}

.feature-description {
  color: #6c757d;
  line-height: 1.6;
}

/* 产品优势 */
.advantages-section {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
}

.advantage-item {
  background: white;
  border-radius: 8px;
  padding: 25px;
  text-align: center;
  transition: transform 0.3s ease;
  height: 100%;
}

.advantage-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.advantage-item h3 {
  color: #007bff;
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.advantage-item p {
  color: #6c757d;
  line-height: 1.6;
}

/* 应用场景 */
.scenarios-section {
  background-color: white;
}

.scenario-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.scenario-item:hover {
  background: #e9ecef;
  transform: translateY(-3px);
}

.scenario-item h3 {
  color: #007bff;
  margin-bottom: 10px;
  font-size: 1.3rem;
}

.scenario-item p {
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
}

/* 客户评价 */
.testimonials-section {
  background-color: #f8f9fa;
}

.testimonial-card {
  background: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.rating {
  color: #ffc107;
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.testimonial-content {
  font-style: italic;
  color: #6c757d;
  line-height: 1.8;
  margin-bottom: 25px;
}

.testimonial-author {
  display: flex;
  align-items: center;
  justify-content: center;
}

.author-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 15px;
  object-fit: cover;
}

.author-info h4 {
  margin: 0;
  color: #343a40;
}

.author-info p {
  margin: 5px 0 0;
  color: #6c757d;
  font-size: 0.9rem;
}

/* 联系咨询 */
.contact-section {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
}

.contact-section .section-title {
  color: white;
}

.contact-form-container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #343a40;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  background: #007bff;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: background 0.3s ease;
}

.submit-btn:hover {
  background: #0056b3;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-title {
    font-size: 2.5rem;
  }
  
  section {
    padding: 50px 0;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .feature-card,
  .advantage-item,
  .testimonial-card {
    padding: 20px;
  }
  
  .contact-form-container {
    padding: 25px;
  }
}

@media (max-width: 480px) {
  .page-header {
    padding: 40px 0;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-subtitle {
    font-size: 1rem;
  }
  
  section {
    padding: 40px 0;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
}
</style>